/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 6/24/15.
 */
'use strict';
angular.module('prism-ui.components').directive('dropdownSelect', function (_, $filter, $timeout) {
    return {
        restrict: 'E',
        templateUrl: 'components/visual/dropdown-select/dropdown-select-template.html',
        require: 'ngModel',
        scope: {
            attachToBody: '=',
            btnMinWidth: '=',
            clearable: '=',
            collection: '=',
            collectionFilter: '=',
            componentDisabled: '=ngDisabled',
            defaultSelectIndex: '=',
            dropdownClick: '&',
            dropup: '=',
            ignoreLocks: '=',
            labelField: '@',
            labelFunction: '=',
            maxHeight: '<',
            modelProp: '@',
            onChange: '&',
            onClear: '&',
            prompt: '@',
            ngRequired: '<',
            showdates: '=',
            showLoading: '=',
            sortCollection: '@',
            tooltipClass: '@',
            tooltipTemplate: '=',
            trackBy: '@',
            updateButtonPrompt: '=',
            valueProp: '@',
        },
        link: function (scope, element, attrs, modelController) {
            var MAX_NUM_RENDER_ITEMS_ON_INIT = 100;
            var sortCollection = (scope.sortCollection !== undefined) ? attrs.sortCollection === 'true' : true;

            const getCollection = () => {
                return (!!scope.collectionFilter) ? $filter('filter')(scope.collection, scope.collectionFilter) : scope.collection;
            };

            const setViewValue = (value, trigger) => {
                scope.getSelectedIndex.cache.clear();
                modelController.$setViewValue(value, trigger);
            };

            scope.numItemsToRender = MAX_NUM_RENDER_ITEMS_ON_INIT;
            var isRenderingAllItems = false;
            scope.$watch('dropdown.isopen', function (isOpen, wasOpen) {
                if (wasOpen && !isOpen) {
                    modelController.$setTouched();
                }
            });

            scope.isLoading = function() {
                return scope.showLoading || isRenderingAllItems;
            };

            scope.$watch('collection', function (collection) {
                if (collection && collection.length > 1 && scope.labelField && !scope.trackBy && sortCollection) {
                    collection.sort(function (a, b) {
                        if (a[scope.labelField].toLowerCase() < b[scope.labelField].toLowerCase()) {
                            return -1;
                        }
                        if (a[scope.labelField].toLowerCase() > b[scope.labelField].toLowerCase()) {
                            return 1;
                        }
                        return 0;
                    });
                } else if (collection && collection.length > 1 && scope.labelField && scope.trackBy && sortCollection) {
                    collection.sort(function (a, b) {
                        if (a[scope.trackBy][scope.labelField].toLowerCase() < b[scope.trackBy][scope.labelField].toLowerCase()) {
                            return -1;
                        }
                        if (a[scope.trackBy][scope.labelField].toLowerCase() > b[scope.trackBy][scope.labelField].toLowerCase()) {
                            return 1;
                        }
                        return 0;
                    });
                }

                scope.getSelectedIndex.cache.clear();
                if (!modelController.$modelValue && angular.isDefined(scope.defaultSelectIndex) && !!scope.collection) {
                    var filteredCollection = getCollection();
                    if (scope.defaultSelectIndex >= 0 && scope.defaultSelectIndex < filteredCollection.length) {
                        modelController.$setViewValue(filteredCollection[scope.defaultSelectIndex]);
                    }
                }
            });

            function getButtonLabel(viewValue) {
                var dateString = '', startYear, endYear;
                if (scope.labelFunction) {
                    return scope.labelFunction(viewValue, scope.labelField);
                }

                if (scope.showdates && viewValue.hasOwnProperty('startDate') && viewValue.hasOwnProperty('endDate')) {
                    startYear = (viewValue.startDate) ? '' + new Date(viewValue.startDate).getUTCFullYear() : '';
                    endYear = (viewValue.endDate) ? '' + new Date(viewValue.endDate).getUTCFullYear() : '';
                    dateString = (startYear && endYear) ? ' (' + startYear + ' - ' + endYear + ')' : '';
                }
                if (!scope.labelField) {
                    return viewValue;
                } else if (!scope.trackBy) {
                    if (viewValue && viewValue[scope.labelField]) {
                        return viewValue[scope.labelField] + dateString;
                    } else {
                        return scope.prompt || '';
                    }

                } else {
                    if (typeof viewValue[scope.trackBy] !== 'string') {
                        if (viewValue && viewValue[scope.trackBy] && viewValue[scope.trackBy][scope.labelField]) {
                            return viewValue[scope.trackBy][scope.labelField] + dateString;
                        } else {
                            return scope.prompt || '';
                        }

                    } else {
                        if (viewValue && viewValue[scope.labelField]) {
                            return viewValue[scope.labelField] + dateString;
                        } else {
                            return scope.prompt || '';
                        }
                    }
                }
            }

            function findValueInFilteredOptions(filteredCollection, value) {
                if (scope.modelProp) {
                    for (var i = 0; i < filteredCollection.length; i++) {
                        if (filteredCollection[i][scope.modelProp] === value) {
                            return i;
                        }
                    }
                    return -1;
                } else {
                    return filteredCollection.indexOf(value);
                }
            }

            scope.getLabelForViewValue = function () {
                return (modelController.$viewValue) ? getButtonLabel(modelController.$viewValue) : scope.buttonPrompt;
            };

            modelController.$render = function () {
                scope.buttonPrompt = scope.prompt || '';
                scope.buttonPrompt = scope.getLabelForViewValue();
            };

            modelController.$formatters.push(function (modelValue) {
                if (modelValue) {
                    if (scope.modelProp) {
                        var selectedValue;
                        for (var i = 0; i < _.size(scope.collection); ++i) {
                            if (scope.collection[i][scope.modelProp] === modelValue) {
                                selectedValue = scope.collection[i][scope.valueProp];
                                break;
                            }
                        }
                        var returnObj = {};
                        returnObj[scope.modelProp] = modelValue;
                        returnObj[scope.valueProp] = selectedValue;
                        return returnObj;
                    }
                    return modelValue;
                }
            });

            modelController.$parsers.push(function (viewValue) {
                return scope.modelProp ? _.get(viewValue, scope.modelProp) : viewValue;
            });

            modelController.$isEmpty = (viewValue) => {
                if (scope.modelProp) {
                    return !_.get(viewValue, scope.modelProp);
                }
                return !viewValue;
            };

            var getMenuItemPanel = function () {
                if (scope.attachToBody) {
                    var ulElem = _.find(angular.element(document.body).children(), function (child) {
                        return child.tagName.toLowerCase() === 'ul' && child.style.display === 'block';
                    });
                    return angular.element(ulElem);
                } else {
                    return element.find('ul');
                }
            };

            function scrollToSelectedOption() {
                if (!_.isNil(modelController.$viewValue)) {
                    var menuPanel = getMenuItemPanel();
                    var selectedMenuItem = menuPanel.find('li > a').filter(function (index, item) {
                        return '' + item.text === '' + scope.dropdownLabelFunction(modelController.$viewValue);
                    })[0];
                    if (selectedMenuItem) {
                        menuPanel[0].scrollTop = selectedMenuItem.offsetTop;
                        selectedMenuItem.focus();
                    }
                    menuPanel[0].scrollLeft = 0;
                }
            }

            function handleDropDownEvent(event) {
                event.preventDefault();
                event.stopPropagation();
                scope.dropdown.isopen = !scope.dropdown.isopen;

                if (scope.dropdown.isopen) {
                    scope.getSelectedIndex.cache.clear();
                    if (_.size(scope.collection) <= scope.numItemsToRender) {
                        scope.numItemsToRender = Infinity;
                        $timeout(scrollToSelectedOption);
                    } else if (!isRenderingAllItems) {
                        isRenderingAllItems = true;
                        // Render dropdown before adding rest of the items... & when done, scroll
                        $timeout(() => {
                            scope.numItemsToRender = Infinity;
                            $timeout(() => {
                                scrollToSelectedOption();
                                isRenderingAllItems = false;
                            });
                        });
                    }
                    scope.dropdownClick();
                }
            }

            scope.dropdownLabelFunction = function (item) {
                var dateString = '';
                if (scope.labelFunction) {
                    if (scope.updateButtonPrompt) {
                        scope.buttonPrompt = scope.labelFunction(modelController.$modelValue, scope.labelField);
                        scope.updateButtonPrompt = false;
                    }
                    return scope.labelFunction(item, scope.labelField);
                }
                if (scope.showdates && item.hasOwnProperty('startDate') && item.hasOwnProperty('endDate')) {
                    var startYear = (item.startDate) ? '' + new Date(item.startDate).getUTCFullYear() : '';
                    var endYear = (item.endDate) ? '' + new Date(item.endDate).getUTCFullYear() : '';
                    dateString = (startYear && endYear) ? ' (' + startYear + ' - ' + endYear + ')' : '';
                }
                if (!scope.labelField) {
                    return item;
                } else if (!scope.trackBy) {
                    return _.get(item, scope.labelField, '') + dateString;
                } else if (typeof item[scope.trackBy] !== 'string') {
                    return _.get(item, scope.trackBy +'.'+ scope.labelField, '') + dateString;
                } else {
                    return _.get(item, scope.labelField, '') + dateString;
                }
            };

            scope.getTooltipTemplate = function (item) {
                if (scope.dropdown.isopen && scope.tooltipTemplate !== undefined) {
                    scope.tooltipData = item;
                    return scope.tooltipTemplate;
                } else {
                    return '';
                }
            };

            const getSelectedIndexImpl = () => {
                var selectedIndex = findValueInFilteredOptions(scope.collection, modelController.$modelValue);
                if (selectedIndex < 0) {
                    var selectedLabel = scope.dropdownLabelFunction(modelController.$viewValue);
                    selectedIndex = _.findIndex(scope.collection, function(item) {
                        return selectedLabel === scope.dropdownLabelFunction(item);
                    });
                }
                return selectedIndex;
            };
            scope.getSelectedIndex = _.memoize(getSelectedIndexImpl);

            scope.isIndexSelected = (index) => {
                if (!modelController.$modelValue || _.isNil(modelController.$viewValue)) {
                    return false;
                }

                return scope.getSelectedIndex() === index;
            };

            scope.selectOption = function (option, event) {
                if ((!scope.ignoreLocks && option.locked) || option.disabled) {
                    event.preventDefault();
                    event.stopPropagation();
                } else {
                    var oldValue = modelController.$modelValue;
                    if (event) {
                        handleDropDownEvent(event);
                    }
                    setViewValue(option);
                    if (scope.onChange) {
                        scope.onChange({
                            $selected: option,
                            $oldValue: oldValue
                        });
                    }
                    modelController.$render();
                }
            };

            scope.selectOptionFromKey = function (event) {
                var filteredCollection = getCollection();
                var optionToSelect = null, currentIndex;
                if (event.keyCode === 38) {
                    //up arrow
                    event.preventDefault();
                    event.stopPropagation();
                    currentIndex = findValueInFilteredOptions(filteredCollection, modelController.$modelValue);
                    if (currentIndex === -1) {
                        currentIndex = filteredCollection.length;
                    }
                    while (currentIndex - 1 > -1) {
                        if (!filteredCollection[--currentIndex].locked || scope.ignoreLocks) {
                            optionToSelect = filteredCollection[currentIndex];
                            break;
                        }
                    }
                    if (optionToSelect) {
                        setViewValue(optionToSelect);
                        modelController.$render();
                        getMenuItemPanel().find('li > a').filter(function (index, item) {
                            return item.text === scope.dropdownLabelFunction(optionToSelect);
                        })[0].focus();
                    }
                } else if (event.keyCode === 40) {
                    //down arrow
                    event.preventDefault();
                    event.stopPropagation();
                    currentIndex = findValueInFilteredOptions(filteredCollection, modelController.$modelValue);
                    while (currentIndex + 1 < filteredCollection.length) {
                        if (!filteredCollection[++currentIndex].locked || scope.ignoreLocks) {
                            optionToSelect = filteredCollection[currentIndex];
                            break;
                        }
                    }
                    if (optionToSelect) {
                        setViewValue(optionToSelect);
                        modelController.$render();
                        getMenuItemPanel().find('li > a').filter(function (index, item) {
                            return item.text === scope.dropdownLabelFunction(optionToSelect);
                        })[0].focus();
                    }

                } else if (event.keyCode >= 48 && event.keyCode <= 90) {
                    event.preventDefault();
                    event.stopPropagation();
                    var focusOption = null;
                    var key = String.fromCharCode(event.keyCode).toLowerCase();
                    var menuItems = getMenuItemPanel().find('li > a');
                    menuItems = menuItems.filter(function (index, item) {
                        return item.text.charAt(0).toLowerCase() === key && angular.element(item).find('i').length === 0;
                    });

                    if (scope.focusedOption && scope.focusedOption.charAt(0).toLowerCase() === key && menuItems.length > 1) {
                        var focusedIndex = -1;
                        for (var i = 0; i < menuItems.length; i++) {
                            var option = menuItems[i];
                            if (option.text === scope.focusedOption) {
                                focusedIndex = i;
                                break;
                            }
                        }
                        if (focusedIndex + 1 < menuItems.length) {
                            focusOption = menuItems[focusedIndex + 1];
                            focusOption.focus();
                            scope.focusedOption = focusOption.text;
                        } else {
                            focusOption = menuItems[0];
                            focusOption.focus();
                            scope.focusedOption = focusOption.text;
                        }
                    } else if (menuItems.length > 0) {
                        focusOption = menuItems[0];
                        focusOption.focus();
                        scope.focusedOption = focusOption.text;
                    }

                    if (!scope.dropdown.isopen && focusOption) {
                        optionToSelect = filteredCollection.filter(function (option) {
                            return scope.dropdownLabelFunction(option) === scope.focusedOption;
                        })[0];
                        setViewValue(optionToSelect);
                        modelController.$render();
                    }
                }

            };

            scope.clearOption = function (event) {
                event.preventDefault();
                event.stopPropagation();

                if (!scope.componentDisabled) {
                    if (scope.modelProp) {
                        var nullObj = {};
                        nullObj[scope.modelProp] = null;
                        setViewValue(nullObj);
                    } else {
                        setViewValue(null);
                    }
                    modelController.$render();
                }

                scope.onClear();
            };

            scope.clearVisible = function () {
                return !!scope.clearable && modelController.$modelValue;
            };

            scope.toggleDropDown = function (event) {
                handleDropDownEvent(event);
            };

            function onRequiredUpdate() {
                scope.selectRequired = attrs.required;
                modelController.$validate();
            }

            scope.$watch('ngRequired', onRequiredUpdate);
            modelController.$name = attrs.name;
            scope.focusedOption = null;
            scope.minWidthStyle = (scope.btnMinWidth > 0) ? {'min-width': scope.btnMinWidth + 'px'} : {};
            scope.loadingIndicator = {
                size: 'sm'
            };
        }
    };
});
